import { render, staticRenderFns } from "./pindaanPengesahanSaksi.vue?vue&type=template&id=5634ccca&"
import script from "./pindaanPengesahanSaksi.vue?vue&type=script&lang=js&"
export * from "./pindaanPengesahanSaksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports